<template>
  <ValidationProvider
    v-slot="{ errors, valid, validated }"
    :name="name"
    :rules="getValidation"
    slim
  >
    <basic-form-group
      :id="id"
      :label-is-up="labelIsUp"
      :label="$attrs.label"
      :hint="$attrs.hint"
      :required="$attrs.required"
      :horizontal="$attrs.horizontal"
      :margin="$attrs.margin"
    >
      <textarea
        :id="id"
        v-model="model"
        :class="{'is-invalid': !valid && validated}"
        :name="name"
        v-bind="$attrs"
        class="form-control"
        v-on="listeners"
      />
    </basic-form-group>
  </ValidationProvider>
</template>

<script>
import basicComponentMixin from './basic-component-mixin.js'
export default {
  name: 'BasicTextarea',
  mixins: [basicComponentMixin]
}
</script>
